{
  "name": "parking-admin",
  "version": "2.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "cypress run",
    "test:open": "cypress open",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.20",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.20",
    "@angular/compiler": "^19.2.20",
    "@angular/core": "^19.2.20",
    "@angular/forms": "^19.2.20",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.20",
    "@angular/platform-browser-dynamic": "^19.2.20",
    "@angular/router": "^19.2.20",
    "@ngxs/storage-plugin": "~19.0.0",
    "@ngxs/store": "~19.0.0",
    "dayjs": "^1.11.10",
    "@lkp/parking-sdk": "^20260911.1.0",
    "echarts": "5.6.0",
    "ngx-echarts": "18.0.0",
    "rxjs": "~7.8.0",
    "rxjs-compat": "^6.6.7",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.24",
    "@angular/cli": "~19.2.24",
    "@angular/compiler-cli": "^19.2.20",
    "@cypress/schematic": "^2.5.1",
    "@ngxs/devtools-plugin": "~19.0.0",
    "cypress": "latest",
    "typescript": "~5.8.3"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "*"
  }
}
